import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../../../../core/providers/apiservices';
import { UserDTO } from '../data/UserDTO';
import { ControlDTO } from '../../../../core/data/ControlDTO';
import { ErrorDTO } from '../../../../core/data/ErrorDTO';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UserProvider {
  private header = APIService.getHeader();
  itemret: any;

  constructor(public http: HttpClient, private translate: TranslateService) {}

  /**
   * GET users
   */
  get(): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'user';
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ControlDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);

        
        }
      });
    });
  }

  /**
   * POST user
   */
  post(user: UserDTO): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'user';
      const requestData = JSON.stringify(user);
      this.http.post(url, requestData, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:UserDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * DELETE user by userName
   */
  delete(userName: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      
      let url = `${APIService.API_URL}user?userName=${encodeURIComponent(userName)}`;
      
      this.http.delete(url, { headers: this.header }).subscribe({
        next: (response:UserDTO) => {
          resolve(response);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }
}
